{
  "version": 1,
  "asset_id": "2e983cb8-acfb-4d21-91da-ab62d4d8c2da",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2e983cb8-acfb-4d21-91da-ab62d4d8c2da/home-hero-v2-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2e983cb8-acfb-4d21-91da-ab62d4d8c2da/home-hero-v2-1280.webp",
  "original_filename": "home-hero-v2-1280.webp",
  "size": 35824,
  "content_type": "image/webp",
  "created_at": "2026-10-10T12:40:05Z"
}
